import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { motion } from 'framer-motion';

import StaffTable from '../components/StaffTable';
import { fetchStaff } from '../slices/staffSlice';

const ArchiveStaffPage = () => {
  const dispatch = useDispatch();

  const { filtered } = useSelector((state) => state.staff);

  useEffect(() => {
    dispatch(fetchStaff());
  }, [dispatch]);

  return (
    // 🎨 Design System Applied — StaffTable renders the full page shell + gradient header (isArchivedView)
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <StaffTable isArchivedView />
    </motion.div>
  );
};

export default ArchiveStaffPage;
